"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkbookFieldsQueryGrid = void 0;
const tslib_1 = require("tslib");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const FieldFunctions_1 = require("../field/functions/FieldFunctions");
const WorkbookFieldsDisplayGrid_1 = require("./WorkbookFieldsDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.workbooks && resultData.workbooks[0]
        && resultData.workbooks[0].embeddedDatasources[0] && resultData.workbooks[0].embeddedDatasources[0].fieldsConnection;
}
function mapResultNode(field, resultData) {
    var _a;
    const dataType = 'dataType' in field ? field.dataType : null;
    return Object.assign(Object.assign({}, field), { dataType, workbookId: resultData.workbooks[0].vizportalUrlId, fieldIcon: (0, FieldFunctions_1.iconForField)(field), sheetCount: field.downstreamSheetsConnection ? field.downstreamSheetsConnection.totalCount : null, labels: field.__typename === 'ColumnField' || field.__typename === 'DatasourceField'
            ? (_a = field.columnsConnection) === null || _a === void 0 ? void 0 : _a.nodes.flatMap(t => t.labels, [])
            : [] });
}
function WorkbookFieldsQueryGrid(props) {
    return (react_1.default.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: catalog_queries_1.WorkbookFieldsByIdDocument, partialQueryVariables: {
            workbookVizportalUrlId: props.vizportalUrlId,
            selectedEmbeddedDatasourceId: props.selectedEmbeddedDatasourceId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode }, ({ rowStore }) => (react_1.default.createElement(WorkbookFieldsDisplayGrid_1.WorkbookFieldsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }))));
}
exports.WorkbookFieldsQueryGrid = WorkbookFieldsQueryGrid;
//# sourceMappingURL=WorkbookFieldsQueryGrid.js.map